<template>
  <div class="bg-cw-purple-alt fixed left-0 top-0 z-50">
    <div class="absolute inset-0 noise-overlay"></div>
    <SuccessScreen stroke-color="#7E99F1">
      <div class="flex flex-col heightSm:gap-2 heightMd:gap-4 heightMd:mb-9 mb-16">
        <p class="heightMd:text-lg text-2xl font-bold text-center">You played</p>
        <h1 class="heightMd:text-[50px] text-[100px] font-extrabold text-cw-gold custom-shadow">{{ formedWordCards.map(card => card.letter).join(' ') }}</h1>
        <p class="heightMd:text-lg text-2xl font-bold text-cw-gold tracking-normal text-center">+{{ totalScore }} points</p>
      </div>
      <BaseButton @click="collectPoints" background-color="var(--color-cw-green)" border-color="var(--color-cw-dark)" class="md:px-4 md:py-2.5 lg:px-6 lg:py-3.5">
        <p class="w-full !text-sm md:!text-base xl:!text-xl">Collect Points</p>
      </BaseButton>
    </SuccessScreen>
  </div>
</template>

<script setup lang="ts">
import BaseButton from '@/components/base/BaseButton.vue'
import SuccessScreen from '@/components/game-play/SuccessScreen.vue'
import { useGameArea } from '@/composables/useGameArea'
import { useGameStore } from '@/stores/game'
import { computed } from 'vue'
const { goToGameAreaScreen, formedWordCards } = useGameArea()
const { resumeGameState } = useGameStore()

const totalScore = computed(() => {
  return formedWordCards.value.reduce((acc, card) => acc + card.value, 0)
})

const collectPoints = () => {
  goToGameAreaScreen()
  resumeGameState()
}
</script>

<style scoped>
.custom-shadow {
  text-shadow: 4px 0px 0px #000;
}

.noise-overlay {
  background-image: url('@/assets/images/noise-texture.webp');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
</style>
